import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getNewsDetail, getNews } from '../services/api';

const BlogDetail = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [relatedArticles, setRelatedArticles] = useState([]);

  useEffect(() => {
    setLoading(true);
    getNewsDetail(slug).then(data => {
      setArticle(data);
      setLoading(false);
    });
    getNews({ per_page: 5 }).then(res => {
      const articles = res.data || [];
      const filtered = articles.filter(a => a.slug !== slug).slice(0, 3);
      setRelatedArticles(filtered);
    });
  }, [slug]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  if (loading) return <section id="blog-detail"><div className="wrap"><div className="comp-loading">Loading...</div></div></section>;
  if (!article) return <section id="blog-detail"><div className="wrap"><div className="comp-empty"><p>Article not found.</p><Link to="/blog" className="comp-card-cta">← Back to Blog</Link></div></div></section>;

  return (
    <section id="blog-detail">
      <div className="wrap">
        <div className="blog-detail-header">
          <Link to="/blog" className="blog-back">← Back to Blog</Link>
          <span className="blog-detail-date">{formatDate(article.published_at)}</span>
          <h1 className="blog-detail-title">{article.title}</h1>
        </div>
        {article.excerpt && <p className="blog-detail-excerpt">{article.excerpt}</p>}
        {article.featured_image && (
          <div className="blog-detail-img">
            <img src={article.featured_image} alt={article.title} />
          </div>
        )}
        <div className="blog-detail-content" dangerouslySetInnerHTML={{ __html: article.content }} />

        {/* Related Articles */}
        {relatedArticles.length > 0 && (
          <div className="cd-related">
            <h2 className="cd-related-title">Related Articles</h2>
            <div className="blog-grid" style={{marginTop:'24px'}}>
              {relatedArticles.map((a) => (
                <Link to={`/blog/${a.slug}`} className="blog-card" key={a.id}>
                  <div className="blog-card-img">
                    {a.featured_image ? (
                      <img src={a.featured_image} alt={a.title} />
                    ) : (
                      <div className="blog-card-placeholder"><span>✍️</span></div>
                    )}
                  </div>
                  <div className="blog-card-body">
                    <span className="blog-card-date">{formatDate(a.published_at)}</span>
                    <h3 className="blog-card-title">{a.title}</h3>
                    <p className="blog-card-excerpt">{a.excerpt || ''}</p>
                    <span className="blog-card-link">Read More ↗</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default BlogDetail;
